import React, { useState, useContext } from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import { AuthState } from '../../helpr/authHelper';
import { IdentityDispatchContext, IdentityContext } from '../../context/identity-context';

import esipLogo from '../../assets/e-SIP-logo.png';
import bgPath from '../../assets/login-bg-1.png';
import bgPath2 from '../../assets/login-bg-2.png';
import bgPath3 from '../../assets/login-bg-3.png';
import bgPath4 from '../../assets/login-bg-4.png';

import { faCalendar } from '@fortawesome/free-solid-svg-icons';

import Alert from '../alert/alert';
import BookingWidget from '../listing-calendar/booking-widget';
import { cognitoSignIn, changeAuthState } from '../../helpr/authHelper';
import { AUTH_INVALID_USERNAME, AUTH_INVALID_PASSWORD } from '../../helpr/constants';

import styles from './custom-login.module.scss';
import '../listing-calendar/listing-calendar.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CustomLogin = () => {

  // State
  
  const { loadUserData } = useContext(IdentityDispatchContext);
  const { authState } = useContext(IdentityContext);
  const [showCalendar, setShowCalendar] = useState(false);
  const [signInState, setSignInState] = useState({ username: '', password: '', onLogin: false });
  const [showErr, setShowErr] = useState({
    msg: '',
    type: 'alert-danger-custom',
    isVisible: false,
    onClose: () => setShowErr(err => ({ ...err, isVisible: false })),
  });
  const [check, setCheck] = useState(false);

  // Handlers
  const onChange = e => {
    const { id, value } = e.currentTarget;
    if (!id) return;
    setSignInState(s => ({ ...s, [id]: value }));
  };

  const handleSignIn = async e => {
    e.preventDefault();
    setSignInState(s => ({ ...s, onLogin: true }));
    const { username, password } = signInState;
    try {
      if (!username) throw new Error(AUTH_INVALID_USERNAME);
      if (!password) throw new Error(AUTH_INVALID_PASSWORD);
      
      const result = await cognitoSignIn(username.trim(), password);

      
      if (result?.session && authState !== AuthState.SignedIn) {
        await loadUserData(result.session);
      }


      return;
    } catch (error) {
      console.log('handleSignIn error:', error);
      setShowErr(err => ({
        ...err,
        isVisible: true,
        msg: error.message || 'Username or password is incorrect.',
      }));
      setSignInState(s => ({ ...s, onLogin: false }));
    }
  };

  const handleForgotPassword = () => changeAuthState(AuthState.ForgotPassword);

  const redirectToPrivacyNotice = () => {
    const win = window.open(
      `${process.env.REACT_APP_CLIENT_ENDPOINT}/privacy-notice`,
      '_blank',
      'noopener,noreferrer'
    );
    if (win) win.opener = null;
  };

  const redirectToTerms = () => {
    const win = window.open(
      `${process.env.REACT_APP_CLIENT_ENDPOINT}/terms-conditions`,
      '_blank',
      'noopener,noreferrer'
    );
    if (win) win.opener = null;
  };

  const renderLoginStatement = () => (
    <>
      By clicking <span className={styles['statement-bold']}>LOGIN</span>, I agree to the e-Securities Issue Portal{' '}
      <span className={styles['statement-link']} onClick={redirectToTerms}>
        Terms of Use
      </span>{' '}
      and consent to the collection and use of my personal data as described in the{' '}
      <span className={styles['statement-link']} onClick={redirectToPrivacyNotice}>
        Privacy Notice
      </span>.
    </>
  );

  return (
    <div className={styles['custom-container']}>
      <div className='calendarWrapperStyle'>
        <Button onClick={() => setShowCalendar(true)} disabled={showCalendar} aria-disabled={showCalendar}>
          <FontAwesomeIcon icon={faCalendar}></FontAwesomeIcon> Listing Calendar
        </Button>
        {showCalendar && <BookingWidget onClose={() => setShowCalendar(false)} />}
      </div>

      {/* Static Background & Logo */}
      <div className={styles['static-background']}>
        <img className={styles['right-img']} src={bgPath3} alt="" />
        <img className={styles['left-img']} src={bgPath} alt="" />
        <img className={styles['top-left-img']} src={bgPath4} alt="" />
        <div className={styles['Path']}></div>
        <img className={styles['bottom-left-img']} src={bgPath2} alt="" />
        <img className={styles['logo']} src={esipLogo} alt="e-SIP" />
      </div>

      <Row>
        <div className={styles['right-column']}>
          <Form className={styles['login-wrapper']} onSubmit={handleSignIn}>
            <div className={styles['header']}>Login</div>
            <Alert options={showErr} />

            <div className={styles['body']}>
              <Form.Group controlId="username">
                <Form.Control
                  id="username"
                  className={styles['text-input']}
                  type="text"
                  placeholder="Username"
                  onChange={onChange}
                />
              </Form.Group>

              <Form.Group controlId="password">
                <Form.Control
                  id="password"
                  className={styles['text-input']}
                  type="password"
                  placeholder="Password"
                  onChange={onChange}
                />
              </Form.Group>

              <div className={styles['forgot-pass']}>
                <a href="#" onClick={handleForgotPassword}>
                  Forgot Password?
                </a>
              </div>

              <div className={styles['login-statement']}>
                <label>
                  <input
                    type="checkbox"
                    checked={check}
                    onChange={() => setCheck(c => !c)}
                  />{' '}
                  {renderLoginStatement()}
                </label>
              </div>

              <div className={styles['action-btn']}>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={signInState.onLogin || !check}
                  className={styles['login-button']}
                >
                  {signInState.onLogin ? (
                    <Spinner size="sm" animation="border" />
                  ) : (
                    'LOGIN'
                  )}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Row>
    </div>
  );
};

export default CustomLogin;